import { Splide } from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

document.addEventListener('DOMContentLoaded', function (e) {
    const reviewsBlock = e.target.querySelector('.reviews__block')

    if (reviewsBlock) {
        const jsReviewsSlider = reviewsBlock.querySelector('.js-reviews-slider')

        if (jsReviewsSlider) {
            const splideInstanceReviews = new Splide(jsReviewsSlider, {
                perPage: 3,
                type: 'loop',
                drag: 'free',
                arrows: true,
                pagination: false,
                gap: '30px',
                autoScroll: {
                    speed: .5,
                },
                breakpoints: {
                    991: {
                        perPage: 2,
                    },
                    719: {
                        perPage: 1,
                    },
                },
            })
            splideInstanceReviews.mount( { AutoScroll } )
        }
    }
})
